export function pick<T, K extends keyof T>(object: T, keys: K[]): Pick<T, K> {
  return keys.reduce(
    (newObject, key) => ({
      ...newObject,
      [key]: object[key],
    }),
    {} as Pick<T, K>,
  );
}
